export default __webpack_public_path__ + "static/media/resideo-block-logo-consumer-white.fbe4de1d.svg";